import { h } from "preact";
import { useEffect, useState } from "preact/hooks";

import uploadTaskApi from "../api/uploadTask.js";
import { humanFileSize } from "../helpers.js";

import ListItem from "./ListItem.jsx";

export default function UploadedListItem({ value }) {
  const [fileData, setFileData] = useState(null);

  useEffect(async () => {
    setFileData(await uploadTaskApi.getFileData(value));
  }, []);
  if (!fileData) {
    return (
      <ListItem iconFront="picture_as_pdf" secondLine="…">
        Loading …
      </ListItem>
    );
  }

  return (
    <ListItem
      iconFront="picture_as_pdf"
      secondLine={humanFileSize(fileData.fileSize)}
      link={fileData.url}
      iconBack="file_download"
    >
      {fileData.originalFileName}
    </ListItem>
  );
}
